import React from 'react';
import Box from '@mui/material/Box';
import logo from '@/common/assets/logo.svg';
import LanguageDropdown from '@/common/components/NavigationBar/components/LanguageDropdown';
import authHeaderStyles from '@/common/components/AuthHeader/AuthHeader.styles';
import { useTranslation } from 'react-i18next';
import LogoutLink from '@/common/components/LogoutLink/LogoutLink';
import { MARKETING_SITE_URL } from '@/app/config';

const AuthHeader = ({ withLogout = false }) => {
  const { t } = useTranslation();

  return (
    <Box sx={authHeaderStyles.root}>
      <Box
        component="a"
        href={MARKETING_SITE_URL}
        display="inline-flex"
      >
        <Box
          component="img"
          sx={authHeaderStyles.logo}
          src={logo}
          alt={t('Praedias logo')}
        />
      </Box>
      <Box display="flex" alignItems="baseline" gap={2}>
        {withLogout && <LogoutLink />}
        <LanguageDropdown />
      </Box>
    </Box>
  );
};

export default AuthHeader;
